import { j as e } from "../../../chunks/jsx-runtime.DGlMoOmv.js";
import { FormattedMessage as t } from "react-intl";
import { B as a } from "../../../chunks/Button.Ccj-dDdM.js";
import { T as o } from "../../../chunks/Text.BGhoO_e3.js";
import { c as n } from "../../../chunks/index.CxSWpsOB.js";
const w = ({
  isVisible: s,
  onDismiss: l,
  isLoading: i = !1,
  onConfirm: r
}) => s ? /* @__PURE__ */ e.jsx("div", { className: n("tw-fixed tw-bottom-24 tw-right-24 tw-bg-base-white tw-rounded-8 tw-p-16 tw-shadow-lg tw-w-[358px]"), children: /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-16", children: [
  /* @__PURE__ */ e.jsx(o, { typeface: "headline-1-m", children: /* @__PURE__ */ e.jsx(t, { id: "hZBGIJ", defaultMessage: [{
    type: 0,
    value: "Please confirm that your calendar is up-to-date for the next four Saturdays."
  }] }) }),
  /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-8", children: [
    /* @__PURE__ */ e.jsx(a, { appearance: "black", onClick: r, showSpinner: i, fullWidth: !0, children: /* @__PURE__ */ e.jsx(t, { id: "SEXlnF", defaultMessage: [{
      type: 0,
      value: "Confirm these dates"
    }] }) }),
    /* @__PURE__ */ e.jsx(a, { className: "tw-mt-4", variant: "underline-m", onClick: l, fullWidth: !0, children: /* @__PURE__ */ e.jsx(t, { id: "MBb3Nk", defaultMessage: [{
      type: 0,
      value: "Dismiss for now"
    }] }) })
  ] })
] }) }) : null;
export {
  w as AvailabilityMiniModal
};
//# sourceMappingURL=index.js.map
